import {Box, Flex, Heading, HStack, Image, Stack, Text, VStack} from "@chakra-ui/react";
import {Blogs, BlogTags} from "../../helpers/data-jsons";
import {ReactComponent as Book} from "../../assets/icons/book.svg";
import {ReactComponent as Calendar} from "../../assets/icons/calendar.svg";
import {ReactComponent as Arrow} from "../../assets/icons/arrow_right.svg";
import styles from "./parts/styles";
import {PaginationRow, StyledButton} from "../../components";
import {useState} from "react";
import {Link} from "react-router-dom";

const Blog = () => {
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(4);
    const [tags, setTags] = useState(BlogTags);
    const totalPages = Math.ceil(Blogs.length / itemsPerPage);
    const currentItems = Blogs.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);
    const handleToggleTag = (id) => {
        setTags(prev =>
            prev.map(tag =>
                tag.id === id ? { ...tag, checked: !tag.checked } : tag
            )
        );
    };
    return (
        <Stack
            m={'auto'}
            p={{base:'24px 0',md:'24px 16px'}}
            gap={'24px'}
            css={styles.blog_container}
            maxW={'2xl'}>
            <VStack
                display={{base:'flex',md:'none'}}
                color={'white'}
                w={{base:'94%',sm:'82%'}}
                minW={'169px'}
                maxW={{base:'',md:'385px'}}
                margin={'auto'}
                padding={'16px'}
                border={'1px solid'}
                borderColor={'rgba(88, 52, 168, 1)'}
                gap={'16px'}
                alignItems={'flex-start'}
                height={'max-content'}
                borderRadius={'16px'}>
                <Text
                    width={'full'}
                    color={'neutral.100'}
                    fontSize={'heading.2xl'}>
                    Tags
                </Text>
                <hr style={{border: '1px solid rgba(53, 57, 69, 1)', width: '100%'}}/>
                <Flex
                display={'flex'}
                flexWrap={'wrap'}
                gap={'8px'}
                >

                {
                    tags?.map((tags) => (
                        <StyledButton
                            fontSizeBase={'body.sm'}
                            width={'fit-content'}
                            fontSize={'body.sm'}
                            padding={'12px'}
                            onClick={() => handleToggleTag(tags.id)}
                            bg={tags.checked ? 'purple.500' :'neutral.900'}
                            key={tags.id}>
                            {tags.title}
                        </StyledButton>
                    ))
                }
                </Flex>
                <StyledButton
                    width={'137px'}
                    margin={'auto'}
                    gap={'4px'}
                    borderRadius={'6px'}
                    padding-top={'12px'}
                    padding-right={'10px'}
                    padding-bottom={'12px'}
                    padding-left={'10px'}
                    border-width={'1px'}
                    border-color={'purple.500'}
                    fontSize={'24px'}
                    bg={'purple.200'}
                    height={'24px'}>Reset</StyledButton>
            </VStack>
            <Heading
                padding={{base: '0 16px', md: ''}}
                maxW={'1344px'}
                width={'100%'}
                margin={'auto'}
                textAlign={'start'}
                color={'neutral.100'}
                fontSize={'heading.3xl'}
            >News Blog</Heading>
            <Box
                w={'full'}
                display={'flex'}
                flexDirection={'column'}
                gap={'48px'}
                maxW={'1344px'}
                margin={'auto'}
                bg={'neutral.1100'}
                 p={{base:'24px 10px',md:'24px 32px'}}
                 borderRadius={{base:0,md:'16px'}}>
                <Flex
                    flexDirection={{base: 'column',sm: 'row'}}
                    justifyContent={'center'}
                    w={'full'}
                    gap={'32px'}>

                    <VStack
                        display={{base:'none',md:'flex'}}
                        color={'white'}
                        w={{base:'100%',sm:'fit-content'}}
                        minW={'169px'}
                        padding={'16px'}
                        border={'1px solid'}
                        borderColor={'rgba(88, 52, 168, 1)'}
                        gap={'16px'}
                        alignItems={'flex-start'}
                        height={'max-content'}
                        borderRadius={'16px'}>
                        <Text
                            width={'full'}
                            color={'neutral.100'}
                            fontSize={'heading.2xl'}>
                            Tags
                        </Text>
                        <hr style={{border: '1px solid rgba(53, 57, 69, 1)', width: '100%'}}/>
                        {
                            tags?.map((tags) => (
                                <StyledButton
                                    fontSizeBase={'body.sm'}
                                    width={'fit-content'}
                                    fontSize={'body.sm'}
                                    padding={'12px'}
                                    onClick={() => handleToggleTag(tags.id)}
                                    bg={tags.checked ? 'purple.500' :'neutral.900'}
                                    key={tags.id}>
                                    {tags.title}
                                </StyledButton>
                            ))
                        }

                        <StyledButton fontSize={'12px'} bg={'purple.200'} height={'24px'}>Reset</StyledButton>
                    </VStack>
                    <HStack flexWrap={'wrap'} gap={'24px'}>
                        {
                            currentItems.map((blog) => (
                                <Box
                                    w={{base: '100%',sm: '85%',xm:'48%'}}
                                    margin={'auto'}
                                    borderRadius={'16px'}
                                     borderColor={'neutral.800'}
                                     border={'1px solid rgba(88, 52, 168, 1)'}
                                     key={blog.id}>
                                    <Box>
                                        <Image maxH={'230px'}
                                               borderTopLeftRadius={'16px'}
                                               borderTopRightRadius={'16px'}
                                               w={'full'}
                                               objectFit={'cover'}
                                               src={'/images/' + blog.imgUrl}/>
                                    </Box>
                                    <HStack padding={{base:'10px',md:'24px'}}
                                            fontSize={{base:'14px',lg:'16px'}}
                                            justifyContent={'space-between'}>
                                        <Box bg={'neutral.900'}
                                             display={'flex'}
                                             alignItems={'center'}
                                             gap={'8px'}
                                             padding={'8px 12px'}
                                             borderRadius={'6px'}
                                             color={'neutral.100'}><Book/>{blog.tags.toString()}</Box>
                                        <Text color={'neutral.500'}
                                              display={'flex'}
                                              alignItems={'center'}
                                              gap={'8px'}
                                        ><Calendar/>{blog.createdAt}</Text>
                                    </HStack>
                                    <Box padding={{base:'11px',md:'24px'}}
                                         gap={'16px'}
                                         display={'flex'}
                                         flexDirection={'column'}>
                                        <Heading color={'rgba(88, 52, 168, 1)'} fontWeight={'400'}
                                                 fontSize={'heading.2xl'}>{blog.title}</Heading>
                                        <Text color={'neutral.500'} fontWeight={'400'}
                                              fontSize={'heading.lg'}>{blog.description}</Text>
                                        <StyledButton
                                            as={Link}
                                            to={'/blog/'+blog.id}
                                            padding={'12px 24px 12px 0px'}
                                            gap={'4px'}
                                            fontSize={'16px'}
                                            fontWeight={'500'}
                                            maxW={'max-content'}
                                            bg={'transparent'}>
                                            Read More <Arrow/>
                                        </StyledButton>
                                    </Box>
                                </Box>
                            ))
                        }
                    </HStack>
                </Flex>
                <PaginationRow
                    pageCount={totalPages}
                    onPageChange={setCurrentPage}
                    itemsPerPage={itemsPerPage}
                    onItemsPerPageChange={(newCount) => {
                        setItemsPerPage(newCount);
                        setCurrentPage(0);
                    }}
                />
            </Box>
        </Stack>
    )
}

export default Blog